/**
 * Versão de um modelo a partir do nome: "sabia-4", "sabiazinho-4-br-sp" e o
 * nome curto "s5" (prefixo "s" + número). 0 quando não há versão.
 */
export function modelVersion(name: string): number {
  const lower = name.toLowerCase();
  const match = lower.match(/^s(\d+(?:\.\d+)?)(?:-|$)|-(\d+(?:\.\d+)?)(?:-|$)/);
  return match ? parseFloat(match[1] || match[2]) : 0;
}

/** Mais nova primeiro (maior versão), depois por nome (desc), como no catálogo. */
export function compareModels(a: string, b: string): number {
  const va = modelVersion(a);
  const vb = modelVersion(b);
  if (va !== vb) return vb - va;
  return b.localeCompare(a);
}

/** Geração em destaque no catálogo: a família Sabiá 5 (S5, S5-br-sp, S5-free…). */
export function isFeaturedModel(name: string): boolean {
  return modelVersion(name) >= 5;
}
